import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { CopilotIcon } from '@bingads-webui-react/copilot-ui-base';
import { useCopilotIconStyles } from './styles/copilot-icon-styles';

export const CopilotButton = (props) => {
  const {
    i18n,
    isNewLogo,
  } = props;
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    $('#searchquery').on('keydown', (e) => {
      setSearchQuery(e.target.value);
    });

    $('#searchquery').on('keyup', (e) => {
      setSearchQuery(e.target.value);
    });
  }, []);

  const onClick = useCallback(() => {
    const customizedEvent = {
      eventType: 'message',
      eventData: {
        message: searchQuery || '',
      },
      eventSource: 'apex-help-dropdown-copilot-button',
    };

    const toggleCopilotEvent = new CustomEvent('copilotToggleEvent', {
      detail: customizedEvent,
      bubbles: true,
      cancelable: true,
      composed: false,
    });

    document.dispatchEvent(toggleCopilotEvent);

    window.apex_glb.closeHelpView();
  }, [searchQuery]);

  const onCopilotKeyDown = useCallback((e) => { if (e && e.key === 'Enter') { onClick(); } }, [onClick]);

  const copilotIconStyles = useCopilotIconStyles();

  return (
    <span role="button" tabIndex={0} onClick={onClick} onKeyDown={onCopilotKeyDown}>
      <CopilotIcon
        size="medium"
        color={isNewLogo ? 'multicolor': 'blue'}
        title={i18n.getString(_TL_('Copilot icon'))}
        iconStyles={copilotIconStyles.copilotIcon}
      />
    </span>
  );
};

CopilotButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isNewLogo: PropTypes.bool,
};

CopilotButton.defaultProps = {
  isNewLogo: false,
};
